/* eslint-disable react/jsx-curly-newline */

/* eslint-disable react/prop-types */
import React from 'react';
// import PropTypes from 'prop-types';
import shortid from 'shortid';
// components
import { Grid, Checkbox, Message } from '@design-system-coopeuch/web';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

import { WrapperCheckboxs, WrapperCheckbox } from '../../../assets/styles/styles';

const Needs = (props) => {
  const { question, optionsSelected, validationRequireFields, onSelectOption } = props;

  const titleHeader = (
    <article>
      <p className="font-size-24 line-height-30 font-weight-bold">{question.question}</p>
    </article>
  );

  return (
    <SimpleCard contentHeader={titleHeader}>
      <Grid className="py-4 py-md-6 px-md-6 border-bottom border-neutral-alfa-15">
        <p className="mb-1 mb-md-3 line-height-20">
          ¡Queremos conocerte mejor! Esta encuesta nos ayudará a guiarte en tus preferencias como
          socio Coopeuch.
        </p>
        <WrapperCheckboxs>
          <section className="grid-order-by-columns">
            {question.alternatives.map((el) => (
              // <Fragment key={shortid.generate()}>
              <WrapperCheckbox
                validationStatus={validationRequireFields ? 'error' : 'default'}
                key={shortid.generate()}
              >
                <Checkbox
                  id={shortid.generate()}
                  label={el.description}
                  checked={optionsSelected.some((ele) => ele.idOption === el.idOption)}
                  onChange={(ev) =>
                    onSelectOption({
                      idOption: el.idOption,
                      description: el.description,
                      selected: ev,
                    })
                  }
                />
              </WrapperCheckbox>
              // </Fragment>
            ))}
          </section>
        </WrapperCheckboxs>
        {validationRequireFields && (
          <Grid row className="m-0 mt-2 p-0 w-100">
            <Message
              className="w-100"
              type="error"
              description="Debes seleccionar al menos una opción. Si no estás interesado puedes marcar la opción Ninguna por el momento."
              closer={null}
            />
          </Grid>
        )}
      </Grid>
    </SimpleCard>
  );
};

export default Needs;
